import Vue from 'vue';
import wrap from '@vue/web-component-wrapper';
import infoIconScss from './assets/styles/info-icon.scss';

/**
 * Creates Info Icon Component at the target element
 */
export async function _createInfoIcon(targetElement: Element, InfoIconComponent) {
  // Create logo only if none exists
  const existsInfoIcon = targetElement.querySelector('quadpay-info-icon');
  if (existsInfoIcon) {
    return;
  }

  // we can only define a custom element once
  if (!window.customElements.get('quadpay-info-icon')) {
    window.customElements.define('quadpay-info-icon', wrap(Vue, InfoIconComponent) as any);
  }

  // create custom element
  const infoIcon = document.createElement('quadpay-info-icon') as any;

  const stylesheet = document.createElement('style');
  stylesheet.innerHTML = `${infoIconScss}`;
  infoIcon.shadowRoot.append(stylesheet);

  return await _getInsertInfoIconPromise(targetElement, infoIcon);
}

const _insertInfoIcon = (targetElement, InfoIcon) => {
  if (!document.querySelector('quadpay-info-icon')) {
    targetElement.appendChild(InfoIcon);
  }
};

async function _getInsertInfoIconPromise(targetElement, InfoIconComponent) {
  return await new Promise((resolve) => {
    // if time runs out: add an event listener to insert logo and return current logo object
    // logo object won't have responsive vue props until it is appended onto the DOM
    const timeout = setTimeout(() => {
      if (document.readyState !== 'loading') {
        _insertInfoIcon(targetElement, InfoIconComponent);
      } else {
        document.addEventListener('DOMContentLoaded', () => { _insertInfoIcon(targetElement, InfoIconComponent); });
      }
      clearInterval(retryInterval);
      resolve(InfoIconComponent);
    }, 500);

    const retryInterval = setInterval(() => {
      if (document.readyState !== 'loading') {
        clearTimeout(timeout);
        clearInterval(retryInterval);
        _insertInfoIcon(targetElement, InfoIconComponent);
        resolve(InfoIconComponent);
      }
    }, 5);
  });
}